import Vue from 'vue'
import sakaliApi from '../sakali-api'

const NO_AUTH = {
    token: undefined,
    user: {
        id: -1,
        team: {
            id: -1
        }
    }
}

export default {
    state: {
        authtoken: NO_AUTH,
    },
    mutations: {
        storeAuthtokenPayload(state, payload) {
            state.authtoken = payload;
            sakaliApi.setAuthtoken(payload.token);
            localStorage.setItem('authtoken', payload.token)
            Vue.$cookies.set('sandkastenliga.openapi.authtoken', payload.token)
        },
        clear(state) {
            localStorage.removeItem('authtoken')
            Vue.$cookies.remove('sandkastenliga.openapi.authtoken')
            state.authtoken = NO_AUTH
        }
    },
    actions: {
        async loginAction({commit, dispatch}, credentials) {
            await sakaliApi.post('/authtokens', credentials)
                .then(response => {
                    commit('storeAuthtokenPayload', response.data)
                }).catch(error => {
                    dispatch('handleErrorAction', error)
                })
        },
        async autoLoginAction({commit, getters}) {
            let log = window.console.log;
            log('Starting auto-login ...');
            let at = localStorage.getItem('authtoken');
            let legacyCookie = Vue.$cookies.get('sandkastenliga.openapi.authtoken');
            log('Local storage = ' + at + ', legacy = ' + legacyCookie);
            for (let idx = 0; idx < 2; idx++) {
                let token = [at, legacyCookie][idx];
                if (token != null && !getters.loggedIn) {
                    log('try = ' + (token === at ? 'local' : 'legacy'));
                    await sakaliApi.get(`/authtokens/${token}`).then(response => {
                        commit('storeAuthtokenPayload', response.data)
                    }).catch(() => {
                        // ignore
                    });
                }
            }
        },
        async logoutAction({commit, dispatch, state}) {
            const token = state.authtoken.token
            commit('clear')
            await sakaliApi.delete(`/authtokens/${token}`).then(response => {
                console.log(response);
            }).catch(error => dispatch('handleErrorAction', error));
            Vue.$cookies.remove('sandkastenliga.openapi.authtoken');
            Vue.$cookies.remove('JSESSIONID');
            Vue.$cookies.remove('login');
            Vue.$cookies.remove('password');
            commit('setMessage', {
                message: 'Du wurdest abgemeldet. Nutze den Anmelden-Knopf, um Dich wieder anzumelden!',
                type: 'info'
            })
        },
        refreshUserAction({commit, dispatch, state}) {
            sakaliApi.get(`/authtokens/${state.authtoken.token}`).then(response => {
                commit('storeAuthtokenPayload', response.data)
            }).catch(error => {
                dispatch('handleErrorAction', error)
            })
        }
    },
    getters: {
        authtoken(state) {
            return state.authtoken;
        },
        userId(state) {
            if (state.authtoken === NO_AUTH || !state.authtoken.user)
                return -1
            return state.authtoken.user.id
        },
        user(state) {
            if (state.authtoken === NO_AUTH || !state.authtoken.user)
                return null
            return state.authtoken.user;
        },
        isCoach(state) {
            return state.authtoken.user.team.id > 0
        },
        team(state) {
            if (!state.authtoken || !state.authtoken.user)
                return null
            return state.authtoken.user.team;
        },
        loggedIn(state) {
            return state.authtoken && state.authtoken.user.id > 0;
        }
    }
}
